export const AppAbortController = {
  controllers: {},
  newController(key) {
    const controller = new AbortController();
    this.controllers[key] = controller;
    return controller;
  },
  set(key, controller) {
    this.controllers[key] = controller;
  },
  get(key) {
    return this.controllers[key];
  },
  abort(keyToRemove, reason) {
    const updated = {};
    Object.keys(this.controllers).forEach((key) => {
      if (key !== keyToRemove) {
        updated[key] = this.controllers[key];
      } else {
        this.controllers[key].abort(reason);
      }
    });
    this.controllers = updated;
  },
  abortStartsWith(keyToRemove, reason) {
    const updated = {};
    Object.keys(this.controllers).forEach((key) => {
      if (!key.startsWith(keyToRemove)) {
        updated[key] = this.controllers[key];
      } else {
        this.controllers[key].abort(reason);
      }
    });
    this.controllers = updated;
  },
  getAllKeys() {
    return Object.keys(this.controllers);
  },
};
